import {Button, Image, Text} from '@primer/react-brand'
import {useTheme} from '@primer/styled-react'
import {clsx} from 'clsx'

import Styles from './IdeListItem.module.css'

export const validSizes = ['big', 'medium', 'small'] as const
export const validIds = [
  'github',
  'vscode',
  'vs',
  'xcode',
  'jetbrains',
  'neovim',
  'azuredatastudio',
  'eclipse',
  'raycast',
] as const

export interface IdeListItemProps {
  id: (typeof validIds)[number]
  name: string
  href: string
  image: string | {light: string; dark: string}
  appendix?: string
  onClick?: (ideId: string, ideName: string) => void
  size: (typeof validSizes)[number]
  isListItem?: boolean
}

const defaultProps: Partial<IdeListItemProps> = {}

const IdeListItem = (props: IdeListItemProps) => {
  const initializedProps: IdeListItemProps = {...defaultProps, ...props}
  const {href, id, image, name, appendix, size, isListItem, onClick} = initializedProps

  const {resolvedColorScheme: colorScheme} = useTheme()

  const Tag = isListItem ? 'li' : 'div'

  return (
    <Tag className={clsx(Styles['IdeListItem'], Styles[`IdeListItem--${size}` as keyof typeof Styles])} data-ide={id}>
      <Button
        className={Styles['IdeListItem__button']}
        as="a"
        href={href}
        hasArrow={false}
        {...(onClick && {onClick: () => onClick(id, name)})}
      >
        <Image
          src={typeof image === 'string' ? image : ['dark', 'night'].includes(colorScheme!) ? image.dark : image.light}
          alt=""
          width="70"
          height="70"
        />
        <Text as="div" size="100" weight="normal" className={Styles['IdeListItem__button-text']}>
          {name} <span className="sr-only">{appendix}</span>
        </Text>
      </Button>

      <Text as="div" size="100" weight="normal" className={Styles['IdeListItem__subtext']} aria-hidden="true">
        {name} {appendix}
      </Text>
    </Tag>
  )
}

export default IdeListItem
